'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const WaypointTypes=require('../../../dist-es6/client/domain/waypointTypes');
const pulsarDate=require('pulsar-utils/dist-es6/pulsarDate');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');

const SubmissionErrors={
DestinationTimeBeforeOriginTime:'Destination time cannot be before origin time.',
RouteInfeasible:'No feasible route found, did you leave enough time to travel between locations?',
ServiceUnreachable:'Routing service unreachable, please contact support.',
UnknownError:'Unknown error calculating route, please check form values and try again.',
InvalidWaypoints:'Waypoints cannot be validated, please check fields.'};let


TripPlanningService=function(_BaseService){_inherits(TripPlanningService,_BaseService);_createClass(TripPlanningService,null,[{key:'$inject',get:function()
{
return['drivePlanService','socketService'];
}}]);

function TripPlanningService(drivePlanService,socketService){_classCallCheck(this,TripPlanningService);var _this=_possibleConstructorReturn(this,
_BaseService.call(this));
_this._drivePlanService=drivePlanService;
_this._socketService=socketService;return _this;
}TripPlanningService.prototype.

plan=function(){var ref=_asyncToGenerator(function*(personId,waypointInputs){
let errors=[];

let validatedWaypoints=yield this._getValidatedWaypoints(waypointInputs,errors);
if(!_.exists(validatedWaypoints)){
errors.push(SubmissionErrors.InvalidWaypoints);
return{errors:errors};
}

let scenarioResponse=yield this._drivePlanService.getAndInflateRouteScenario(personId,validatedWaypoints);

if(_.exists(scenarioResponse.status)){
if(scenarioResponse.status==='ROUTE_INFEASIBLE'){
errors.push(SubmissionErrors.RouteInfeasible);
return{errors:errors};
}else
if(scenarioResponse.status==='SERVICE_UNREACHABLE'){
errors.push(SubmissionErrors.ServiceUnreachable);
return{errors:errors};
}else
if(scenarioResponse.status!=='OK'){
errors.push(SubmissionErrors.UnknownError);
return{errors:errors};
}
}

return{
route:scenarioResponse.route,
queryInterval:scenarioResponse.queryInterval,
schedule:scenarioResponse.schedule};

});function plan(personId,waypointInputs){return ref.apply(this,arguments)}return plan}();TripPlanningService.prototype.

_getValidatedWaypoints=function(){var ref=_asyncToGenerator(function*(waypointInputs,errors){
let validatedWaypoints=[];

for(let input of waypointInputs){
let validatedAddress=yield this._getValidatedAddress(input.address);

if(!validatedAddress.valid){
return null;
}

let latLong={
lat:validatedAddress.result.latitude,
long:validatedAddress.result.longitude};


let timeZone=yield this._getTimezoneFromLocation(latLong);
let validatedTime=this._getValidatedTimeWithCorrectOffset(input.displayTime,timeZone);
let waypointTypeIsValid=this._validateWaypointType(input.waypointType);

if(!_.exists(validatedTime)||!waypointTypeIsValid){
return null;
}

validatedWaypoints.push({
address:validatedAddress.result.formattedAddress,
time:validatedTime,
type:input.waypointType.stopType});

}

let previousTime=_.head(validatedWaypoints).time;
for(let waypoint of _.tail(validatedWaypoints)){
if(waypoint.time<previousTime){
errors.push(SubmissionErrors.DestinationTimeBeforeOriginTime);
return null;
}
previousTime=waypoint.time;
}

return validatedWaypoints;
});function _getValidatedWaypoints(waypointInputs,errors){return ref.apply(this,arguments)}return _getValidatedWaypoints}();TripPlanningService.prototype.

_isDateValid=function _isDateValid(dateToValidate){
return _.isDate(dateToValidate)&&!Number.isNaN(dateToValidate.getTime());
};TripPlanningService.prototype.

_getValidatedTimeWithCorrectOffset=function _getValidatedTimeWithCorrectOffset(displayTime,timeZone){
if(!this._isDateValid(displayTime)){
return null;
}
return pulsarDate(displayTime).fromLocalOffsetToOffsetOf(timeZone);
};TripPlanningService.prototype.

_validateWaypointType=function _validateWaypointType(type){
return _.includes(WaypointTypes.all,type);
};TripPlanningService.prototype.

_getValidatedAddress=function(){var ref=_asyncToGenerator(function*(address){
return yield this._socketService.sendAndWaitForResponse('ValidateAddress',address);
});function _getValidatedAddress(address){return ref.apply(this,arguments)}return _getValidatedAddress}();TripPlanningService.prototype.

_getTimezoneFromLocation=function(){var ref=_asyncToGenerator(function*(location){
return yield this._socketService.sendAndWaitForResponse('GetTimezoneForLocation',location);
});function _getTimezoneFromLocation(location){return ref.apply(this,arguments)}return _getTimezoneFromLocation}();return TripPlanningService}(BaseService);

module.exports=TripPlanningService;
//# sourceMappingURL=tripPlanningService.js.map
